module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Puzzle-9f2783cbd29507f3b4a4afcd95dace44.svg";